module.exports = __webpack_public_path__ + "img/steps3.772f1347.svg";